module.exports = __webpack_public_path__ + "static/media/survey.bfc78576.png";